import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { RevealButton, UnmaskedBadge } from './KycRevealControls';

const useStyles = makeStyles(() => ({
    row: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 6,
    },
}));

interface KycImageRevealRowProps {
    documentId?: number | string | null;
    documentType?: string | null;
    // The IMAGE flag, not the number one. An Aadhaar number is never revealable while its
    // image is, so passing `revealable` here would hide the control on exactly the document
    // reviewers most need to open.
    imageRevealable?: boolean | null;
    imageUnmasked?: boolean | null;
    /** ['FRONT','BACK'] for a two-sided document; omit for a single-image one. */
    documentKeys?: Array<string | null>;
    subject: string;
}

// Reveal control for a document image, plus the "no blurred copy" badge. Shared by the hire
// and staff KYC screens so the three state cards do not each grow their own copy.
export const KycImageRevealRow: React.FC<KycImageRevealRowProps> = ({
    documentId,
    documentType,
    imageRevealable,
    imageUnmasked,
    documentKeys,
    subject,
}) => {
    const classes = useStyles();
    if (!documentId) return null;
    return (
        <Box className={classes.row}>
            <RevealButton
                documentId={documentId}
                documentType={documentType}
                revealable={imageRevealable}
                action="UNBLUR_IMAGE"
                documentKeys={documentKeys}
                subject={subject}
            />
            <UnmaskedBadge visible={imageUnmasked} />
        </Box>
    );
};

export default KycImageRevealRow;
